import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { trackMetaEvent } from '../utils/metaPixel';
export const CHECKOUT_URL = 'https://mega-pack-reiki.impultienda.ar/checkout';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
};
export function Section({
  children,
  className = '',
  id = '',
  glow = false
}: SectionProps) {
  const reduceMotion = useReducedMotion();
  return <motion.section id={id} initial={reduceMotion ? false : {
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.45,
    ease: [0.22, 1, 0.36, 1]
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-288" data-mp="aj86vaudd93o">
      {glow && <div className="absolute inset-x-[18%] top-12 -z-10 h-44 rounded-full bg-brand-purpleLight/20 blur-3xl" aria-hidden="true" data-id="element-289" data-mp="1vtorf617guz9" />}
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
};
export function CTAButton({
  children,
  href = CHECKOUT_URL,
  className = '',
  fullWidth = false,
  variant = 'purple'
}: CTAButtonProps) {
  const reduceMotion = useReducedMotion();
  const colorClass = variant === 'purple' ? 'purple-gradient-bg' : 'gold-gradient-bg';
  return <motion.a href={href} onClick={() => trackMetaEvent('InitiateCheckout', {
    content_name: 'MEGA PACK REIKI',
    value: 19000,
    currency: 'ARS'
  })} whileHover={reduceMotion ? undefined : {
    scale: 1.02,
    y: -1
  }} whileTap={reduceMotion ? undefined : {
    scale: 0.98
  }} className={`cta-shimmer relative inline-flex items-center justify-center rounded-full px-8 py-4 text-center text-base font-bold text-white shadow-[0_8px_20px_rgba(76,50,79,0.25)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-ink ${colorClass} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-290" data-mp="2qm6qvye0xgt1">
      <span className="relative z-10" data-id="element-291" data-mp="1ta1fkd2mzoqx">{children}</span>
    </motion.a>;
}